import React from "react";
import { useMergedGameSessions } from "@seabrookstudios/pitch2table";
import { useGameIdFromRoute } from "../WithGameIdFromRoute";
import { idExtractor, useMakeListAndDetail, useMakeListBuilder } from "../../core/useMakeLayout";
import { ListEntry } from "./ListEntry";
import { AddConventionDialog } from "./AddConventionDialog";
import { Path } from "../../Path";
import Box from "@mui/material/Box";
import { NoItemsFound } from "../../publisher/NoItemsFound";
import Typography from "@mui/material/Typography";

const NoConventionsFound = () => (
  <NoItemsFound>
    <Typography align="center">
      No conventions linked to this game. Click the add button to link a convention.
    </Typography>
  </NoItemsFound>
);

const AddConventionAction = () => {
  const gameId = useGameIdFromRoute();
  return <AddConventionDialog gameId={gameId} />;
};

export const ListAndDetail = () => {
  const gameId = useGameIdFromRoute();

  const useMakeList = useMakeListBuilder(
    ListEntry,
    idExtractor,
    "Conventions",
    NoConventionsFound,
    AddConventionAction,
    undefined,
    Path.game(gameId).link()
  );

  const useWrappedQuery = () => useMergedGameSessions(gameId);

  const ListAndDetail = useMakeListAndDetail(useWrappedQuery, [], "conventions", useMakeList, () => <Box />);

  return <ListAndDetail />;
};
